/**
 * A comparação de vetores de estado — card 1864753210497959381.
 *
 * Aqui mora a decisão, e ela é aritmética pura sobre dois `Map`. Nenhum `import`, nem do
 * `yjs`: é o que permite testá-la em qualquer lugar, e é o que torna impossível a versão
 * ingênua desta função — a que mede bytes.
 *
 * ## Por que NÃO bytes
 *
 * O card proíbe (*"2 bytes parecem progresso"*) e a Regra 8.64 do projeto explica o
 * mecanismo: `encodeStateAsUpdate` escreve o conjunto de exclusões INTEIRO junto com os
 * structs novos, e o `deleteSet` não é filtrado pelo vetor de estado. Num documento que já
 * teve **qualquer** remoção — e substituir um texto é uma remoção — o delta nunca mais volta
 * a ser vazio. Um medidor de bytes diria "atrasado" para sempre, e o aviso viraria ruído.
 *
 * O vetor de estado não tem esse problema: ele é `clientId → clock`, conta OPERAÇÕES, e
 * volta a bater exatamente quando o outro lado alcançou.
 */

export interface Divergencia {
  emDia: boolean;
  /** quantas operações este cliente tem e o servidor não */
  operacoesFaltando: number;
  /** de quantos clientes distintos (abas, aparelhos) elas vieram */
  clientesAtrasados: number;
}

/**
 * ⚠️ A comparação é de MÃO ÚNICA, de propósito.
 *
 * Um clock do servidor MAIOR que o local significa que existe trabalho de outra aba ou de
 * outro aparelho que este cliente ainda não baixou. Isso é normal, não é perda de nada, e
 * contá-lo aqui faria o aviso disparar em toda edição colaborativa. A pergunta deste arquivo
 * é uma só: **o que eu escrevi chegou lá?**
 */
export function compararVetores(
  local: Map<number, number>,
  servidor: Map<number, number>
): Divergencia {
  let operacoesFaltando = 0;
  let clientesAtrasados = 0;

  for (const [cliente, relogioLocal] of local) {
    const relogioServidor = servidor.get(cliente) ?? 0;
    if (relogioLocal > relogioServidor) {
      operacoesFaltando += relogioLocal - relogioServidor;
      clientesAtrasados += 1;
    }
  }

  return {
    emDia: operacoesFaltando === 0,
    operacoesFaltando,
    clientesAtrasados,
  };
}
